
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.356.413l-1.465 3.1-3.277.5a.76.76 0 00-.4 1.28l2.374 2.42-.561 3.41a.724.724 0 001.041.79L6 10.303l2.932 1.61a.725.725 0 001.041-.79l-.562-3.41 2.371-2.414a.76.76 0 00-.4-1.28l-3.277-.5L6.643.413a.705.705 0 00-1.287 0z","fill":"#4c4c4c"}})])
          )
        }
      }
    